var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.visibility)?_c('div',[_c('div',{class:{ loader: true, boxed: !!_vm.boxed }},[_c('spinner',{attrs:{"dark":""}})],1)]):_c('div')}
var staticRenderFns = []

export { render, staticRenderFns }